import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "9",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M8.313 7.29c.21.233.21.585 0 .796-.235.234-.586.234-.797 0L4.75 5.296l-2.79 2.79c-.233.234-.585.234-.796 0-.234-.211-.234-.563 0-.797L3.954 4.5l-2.79-2.79c-.234-.233-.234-.585 0-.796a.513.513 0 0 1 .774 0L4.75 3.727 7.54.937a.513.513 0 0 1 .773 0c.234.211.234.563 0 .797L5.523 4.5z"
    }, null, -1)
  ])))
}
export default { render: render }